import ManageQuestionSubjectsDrawer from './ManageQuestionSubjectsDrawer.component';

export default ManageQuestionSubjectsDrawer;
